import '../../css/headerPage.scss';

import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import MonthNav from '../MonthNav';
import { PlusCircle } from 'react-bootstrap-icons';
import PropTypes from 'prop-types';

export const MonthNavHeader = ({
  title,
  onInsert,
  showInsertButton,
  children,
  isOutsideEmployment,
}) => {
  const { t } = useTranslation();
  const insertButton = (
    <Button variant="primary" onClick={onInsert} disabled={isOutsideEmployment}>
      <PlusCircle />
      Inserisci
    </Button>
  );
  return (
    <div className="headerPage content">
      <div className="title">{title}</div>
      <div className="spacer" />
      {children}
      <div className="monthNavContainer">
        <MonthNav />
      </div>
      {showInsertButton && (
        <div className="buttonGroup">
          {isOutsideEmployment ? (
            <Tooltip
              title={
                <span style={{ color: 'black' }}>
                  {t('outsideEmploymentPeriod')}
                </span>
              }
            >
              <span
                role="button"
                aria-label={t('outsideEmploymentPeriod')}
                aria-disabled="true"
                tabIndex={0}
              >
                {insertButton}
              </span>
            </Tooltip>
          ) : (
            insertButton
          )}
        </div>
      )}
    </div>
  );
};

MonthNavHeader.defaultProps = {
  showInsertButton: false,
  isOutsideEmployment: false,
  onInsert: () => {},
  children: <></>,
};

MonthNavHeader.propTypes = {
  title: PropTypes.string.isRequired,
  showInsertButton: PropTypes.bool,
  isOutsideEmployment: PropTypes.bool,
  onInsert: PropTypes.func,
  children: PropTypes.node,
};
